import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-12" }
const _hoisted_4 = { class: "banner-content text-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_6 = { class: "job-details-pages pt-120 mb-120" }
const _hoisted_7 = {
  key: 0,
  class: "container"
}
const _hoisted_8 = { class: "row g-lg-4 gy-5" }
const _hoisted_9 = { class: "col-lg-8" }
const _hoisted_10 = { class: "job-details-content" }
const _hoisted_11 = { class: "job-list-content" }
const _hoisted_12 = { class: "company-area" }
const _hoisted_13 = { class: "logo" }
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 1,
  src: "/assets/images/work-pages-logo.png",
  alt: "",
  style: {"width":"75px","height":"75px"}
}
const _hoisted_16 = { class: "company-details" }
const _hoisted_17 = { class: "name-location" }
const _hoisted_18 = { href: "#" }
const _hoisted_19 = { class: "job-discription" }
const _hoisted_20 = { class: "one" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/map-2.svg",
  alt: ""
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Location:", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/category-2.svg",
  alt: ""
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Category:", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/company-2.svg",
  alt: ""
}, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Job Type:", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/salary-2.svg",
  alt: ""
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Salary:", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", null, "Job Description:", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h6", { class: "mt-3" }, "Educational Requirements:", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h6", null, "Experiences:", -1)
const _hoisted_33 = { class: "col-lg-4" }
const _hoisted_34 = { class: "job-details-sidebar mb-120" }
const _hoisted_35 = {
  class: "save-apply-btn d-flex justify-content-end mb-50",
  id: "user-applied-on-job"
}
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("b", null, "You have already Applied for this job", -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { class: "job-summary-area mb-50" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "job-summary-title" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Job Summary:")
], -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Job Posted:", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Expiration:", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Vacancy:", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Experiences:", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Education:", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Gender:", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "view-job-btn mb-30" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "job-listing1.html" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/assets/images/icon/company-2.svg",
      alt: ""
    }),
    /*#__PURE__*/_createTextVNode("View All Jobs In This Company")
  ])
], -1)
const _hoisted_49 = { class: "job-share-area mb-50" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("h6", null, "Job Link Share:", -1)
const _hoisted_51 = ["title"]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", { class: "bx bx-link" }, null, -1)
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("i", { class: "bx bxl-facebook" }, null, -1)
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = /*#__PURE__*/_createElementVNode("i", { class: "bx bxl-twitter" }, null, -1)
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("i", { class: "bx bxl-linkedin" }, null, -1)
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = /*#__PURE__*/_createElementVNode("i", { class: "bx bxl-instagram-alt" }, null, -1)
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = {
  key: 0,
  class: "mt-0 alert alert-success"
}
const _hoisted_63 = {
  key: 1,
  class: "location-area"
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("h6", null, "Get Location:", -1)
const _hoisted_65 = ["src"]
const _hoisted_66 = { class: "row" }
const _hoisted_67 = {
  key: 0,
  class: "col-lg-12",
  id: "user-applied-on-job-form"
}
const _hoisted_68 = {
  class: "related-jobs",
  id: "scrollTarget"
}
const _hoisted_69 = { class: "section-title mb-40" }
const _hoisted_70 = { class: "row g-lg-4 gy-5" }
const _hoisted_71 = { class: "col-lg-8" }
const _hoisted_72 = { class: "my-profile-inner" }
const _hoisted_73 = { class: "form-wrapper mb-60" }
const _hoisted_74 = { class: "profile-form" }
const _hoisted_75 = { class: "row" }
const _hoisted_76 = { class: "col-md-6" }
const _hoisted_77 = { class: "form-inner mb-25" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("label", null, "Upload your resume (optional)", -1)
const _hoisted_79 = { class: "input-area" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/user-2.svg",
  alt: ""
}, null, -1)
const _hoisted_81 = { key: 0 }
const _hoisted_82 = { class: "col-md-6" }
const _hoisted_83 = { class: "form-inner mb-25" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("label", null, "Your current position", -1)
const _hoisted_85 = { class: "input-area" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/clock-2.svg ",
  alt: ""
}, null, -1)
const _hoisted_87 = { class: "col-md-6" }
const _hoisted_88 = { class: "form-inner mb-25" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("label", null, "Salary expectation", -1)
const _hoisted_90 = { class: "input-area" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/clock-2.svg ",
  alt: ""
}, null, -1)
const _hoisted_92 = { class: "col-md-6" }
const _hoisted_93 = { class: "form-inner mb-25" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("label", null, "Salary period", -1)
const _hoisted_95 = { class: "input-area" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/clock-2.svg ",
  alt: ""
}, null, -1)
const _hoisted_97 = { class: "col-md-12" }
const _hoisted_98 = { class: "form-inner mb-25" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("label", null, "Your experience", -1)
const _hoisted_100 = { class: "input-area" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/clock-2.svg ",
  alt: ""
}, null, -1)
const _hoisted_102 = { class: "col-md-12" }
const _hoisted_103 = { class: "form-inner" }
const _hoisted_104 = {
  key: 1,
  class: "primry-btn-2 lg-btn w-unset",
  type: "button"
}
const _hoisted_105 = /*#__PURE__*/_createElementVNode("span", { class: "me-3 fs-6 text-white" }, "Processing...", -1)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-spinner fa-spin text-white ms-3",
  style: {"font-size":"24px"}
}, null, -1)
const _hoisted_107 = [
  _hoisted_105,
  _hoisted_106
]
const _hoisted_108 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_109 = { class: "col-lg-12" }
const _hoisted_110 = { class: "related-jobs" }
const _hoisted_111 = /*#__PURE__*/_createStaticVNode("<div class=\"section-title mb-40\"><h3>Related Jobs:</h3><div class=\"swiper-btn1 d-flex align-items-center\"><div class=\"left-btn prev-4\"><img src=\"/assets/images/icon/explore-elliose.svg\" alt=\"\"></div><div class=\"right-btn next-4\"><img src=\"/assets/images/icon/explore-elliose.svg\" alt=\"\"></div></div></div>", 1)
const _hoisted_112 = { class: "swiper related-job-slider" }
const _hoisted_113 = { class: "swiper-wrapper" }
const _hoisted_114 = { class: "feature-card" }
const _hoisted_115 = { class: "company-area" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/images/work-pages-logo.png",
    alt: ""
  })
], -1)
const _hoisted_117 = { class: "company-details" }
const _hoisted_118 = { class: "name-location" }
const _hoisted_119 = { href: "job-details.html" }
const _hoisted_120 = { class: "job-discription" }
const _hoisted_121 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/arrow2.svg",
  alt: ""
}, null, -1)
const _hoisted_122 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Salary:", -1)
const _hoisted_123 = { class: "time" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/arrow2.svg",
  alt: ""
}, null, -1)
const _hoisted_125 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Vacancy:", -1)
const _hoisted_126 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/arrow2.svg",
  alt: ""
}, null, -1)
const _hoisted_127 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Deadline:", -1)
const _hoisted_128 = { class: "job-type-apply" }
const _hoisted_129 = { class: "apply-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "inner-banner",
      style: _normalizeStyle(_ctx.bgImage)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", {
                style: _normalizeStyle(_ctx.textColor)
              }, "Job Details", 4),
              _hoisted_5
            ])
          ])
        ])
      ])
    ], 4),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.current_job)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        (_ctx.current_job.company_logo)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.current_job.company_logo,
                              style: {"width":"75px","height":"75px"}
                            }, null, 8, _hoisted_14))
                          : (_openBlock(), _createElementBlock("img", _hoisted_15))
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("h5", null, [
                            _createElementVNode("a", _hoisted_18, _toDisplayString(_ctx.current_job.job_title), 1)
                          ]),
                          _createElementVNode("p", null, _toDisplayString(_ctx.current_job.working_mode), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("ul", _hoisted_20, [
                        _createElementVNode("li", null, [
                          _hoisted_21,
                          _createElementVNode("p", null, [
                            _hoisted_22,
                            _createTextVNode(" " + _toDisplayString(_ctx.current_job.location), 1)
                          ])
                        ]),
                        _createElementVNode("li", null, [
                          _hoisted_23,
                          _createElementVNode("p", null, [
                            _hoisted_24,
                            _createTextVNode(" " + _toDisplayString(_ctx.current_job.category), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("ul", null, [
                        _createElementVNode("li", null, [
                          _hoisted_25,
                          _createElementVNode("p", null, [
                            _hoisted_26,
                            _createTextVNode(" " + _toDisplayString(_ctx.current_job.job_type), 1)
                          ])
                        ]),
                        _createElementVNode("li", null, [
                          _hoisted_27,
                          _createElementVNode("p", null, [
                            _hoisted_28,
                            _createTextVNode(" " + _toDisplayString(_ctx.current_job.salary_range), 1)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("p", null, [
                    _hoisted_29,
                    _createTextVNode(" " + _toDisplayString(_ctx.current_job.job_description), 1)
                  ]),
                  _hoisted_30,
                  _hoisted_31,
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, _toDisplayString(_ctx.current_job.qualification), 1)
                  ]),
                  _hoisted_32,
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, _toDisplayString(_ctx.current_job.experience) + " Years in this field.", 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    (!_ctx.user_current_job_applied)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_36, [
                          _createElementVNode("li", null, [
                            _createElementVNode("button", {
                              class: "primry-btn-2 lg-btn",
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.applyBtn && _ctx.applyBtn(...args))),
                              type: "click"
                            }, "Apply Now")
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.user_current_job_applied)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_37, _hoisted_39))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _createElementVNode("p", null, [
                          _hoisted_42,
                          _createTextVNode(" " + _toDisplayString(_ctx.current_job.posted_on), 1)
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("p", null, [
                          _hoisted_43,
                          _createTextVNode(" " + _toDisplayString(_ctx.current_job.expiration), 1)
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("p", null, [
                          _hoisted_44,
                          _createTextVNode(" " + _toDisplayString(_ctx.current_job.vacancy) + " Person.", 1)
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("p", null, [
                          _hoisted_45,
                          _createTextVNode(" " + _toDisplayString(_ctx.current_job.experience) + " Years. ", 1)
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("p", null, [
                          _hoisted_46,
                          _createTextVNode(_toDisplayString(_ctx.current_job.qualification), 1)
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("p", null, [
                          _hoisted_47,
                          _createTextVNode(" " + _toDisplayString(_ctx.current_job.gender), 1)
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_48,
                  _createElementVNode("div", _hoisted_49, [
                    _hoisted_50,
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _createElementVNode("span", {
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copyLink && _ctx.copyLink(...args))),
                          style: {"cursor":"pointer"},
                          title: _ctx.titleText
                        }, _hoisted_53, 8, _hoisted_51)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.shareOnFacebook && _ctx.shareOnFacebook(...args)))
                        }, _hoisted_55)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.shareOnTwitter && _ctx.shareOnTwitter(...args)))
                        }, _hoisted_57)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.shareOnLinkedIn && _ctx.shareOnLinkedIn(...args)))
                        }, _hoisted_59)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.shareOnInstagram && _ctx.shareOnInstagram(...args)))
                        }, _hoisted_61)
                      ])
                    ])
                  ]),
                  (_ctx.isCopied)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_62, "link copied successfully"))
                    : _createCommentVNode("", true),
                  (_ctx.current_job.state)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                        _hoisted_64,
                        _createElementVNode("iframe", {
                          src: _ctx.mapUrl,
                          style: {"border":"0"},
                          allowfullscreen: "",
                          loading: "lazy",
                          referrerpolicy: "no-referrer-when-downgrade"
                        }, null, 8, _hoisted_65)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_66, [
              (_ctx.role == 'Job Seeker' && !_ctx.user_current_job_applied)
                ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("h3", null, "Apply For " + _toDisplayString(_ctx.current_job.job_title), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("form", _hoisted_74, [
                              _createElementVNode("div", _hoisted_75, [
                                _createElementVNode("div", _hoisted_76, [
                                  _createElementVNode("div", _hoisted_77, [
                                    _hoisted_78,
                                    _createElementVNode("div", _hoisted_79, [
                                      _hoisted_80,
                                      _createElementVNode("input", {
                                        onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args))),
                                        type: "file",
                                        accept: "application/pdf",
                                        name: "cv"
                                      }, null, 32)
                                    ]),
                                    (_ctx.user.cv !== null)
                                      ? (_openBlock(), _createElementBlock("label", _hoisted_81, "CV already uploaded"))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_82, [
                                  _createElementVNode("div", _hoisted_83, [
                                    _hoisted_84,
                                    _createElementVNode("div", _hoisted_85, [
                                      _hoisted_86,
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.application.designation) = $event)),
                                        placeholder: "What is your current job title"
                                      }, null, 512), [
                                        [_vModelText, _ctx.application.designation]
                                      ])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_87, [
                                  _createElementVNode("div", _hoisted_88, [
                                    _hoisted_89,
                                    _createElementVNode("div", _hoisted_90, [
                                      _hoisted_91,
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.application.salary) = $event)),
                                        placeholder: "What is your expected salary ?"
                                      }, null, 512), [
                                        [_vModelText, _ctx.application.salary]
                                      ])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_92, [
                                  _createElementVNode("div", _hoisted_93, [
                                    _hoisted_94,
                                    _createElementVNode("div", _hoisted_95, [
                                      _hoisted_96,
                                      _createVNode(_component_Dropdown, {
                                        modelValue: _ctx.application.salary_period,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.application.salary_period) = $event)),
                                        options: _ctx.periods,
                                        optionLabel: "name",
                                        optionValue: "id",
                                        placeholder: "Select salary period"
                                      }, null, 8, ["modelValue", "options"])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_97, [
                                  _createElementVNode("div", _hoisted_98, [
                                    _hoisted_99,
                                    _createElementVNode("div", _hoisted_100, [
                                      _hoisted_101,
                                      _createVNode(_component_Dropdown, {
                                        modelValue: _ctx.application.experience,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.application.experience) = $event)),
                                        options: _ctx.exp_options,
                                        optionLabel: "name",
                                        optionValue: "id",
                                        placeholder: "How many years of experience do you have?"
                                      }, null, 8, ["modelValue", "options"])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_102, [
                                  _createElementVNode("div", _hoisted_103, [
                                    (!_ctx.isLoading)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.applyForPosition && _ctx.applyForPosition(...args))),
                                          class: "primry-btn-2 lg-btn w-unset",
                                          type: "button"
                                        }, "Submit Application"))
                                      : (_openBlock(), _createElementBlock("button", _hoisted_104, _hoisted_107))
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _hoisted_108
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_109, [
                _createElementVNode("div", _hoisted_110, [
                  _hoisted_111,
                  _createElementVNode("div", _hoisted_112, [
                    _createElementVNode("div", _hoisted_113, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobs, (job) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: job.id,
                          class: "swiper-slide"
                        }, [
                          _createElementVNode("div", _hoisted_114, [
                            _createElementVNode("div", _hoisted_115, [
                              _hoisted_116,
                              _createElementVNode("div", _hoisted_117, [
                                _createElementVNode("div", _hoisted_118, [
                                  _createElementVNode("h5", null, [
                                    _createElementVNode("a", _hoisted_119, _toDisplayString(job.job_title), 1)
                                  ]),
                                  _createElementVNode("p", null, _toDisplayString(job.working_mode), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_120, [
                              _createElementVNode("ul", null, [
                                _createElementVNode("li", null, [
                                  _hoisted_121,
                                  _createElementVNode("p", null, [
                                    _hoisted_122,
                                    _createTextVNode(" " + _toDisplayString(job.salary_range) + " / ", 1),
                                    _createElementVNode("span", _hoisted_123, _toDisplayString(job.payment_mode), 1)
                                  ])
                                ]),
                                _createElementVNode("li", null, [
                                  _hoisted_124,
                                  _createElementVNode("p", null, [
                                    _hoisted_125,
                                    _createTextVNode(),
                                    _createElementVNode("span", null, _toDisplayString(job.vacancy) + " Person (" + _toDisplayString(job.gender) + ")", 1)
                                  ])
                                ]),
                                _createElementVNode("li", null, [
                                  _hoisted_126,
                                  _createElementVNode("p", null, [
                                    _hoisted_127,
                                    _createTextVNode(),
                                    _createElementVNode("span", null, _toDisplayString(job.expiration), 1)
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_128, [
                              _createElementVNode("div", _hoisted_129, [
                                _createVNode(_component_router_link, {
                                  class: "primry-btn-2 y-btn lg-btn",
                                  to: { name: 'job-details', query: { job_id: job.id } }
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Apply Now")
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}